import * as React from 'react';
import { observer } from 'mobx-react';
import * as PropTypes from 'prop-types';

import useStores from '../../../../hooks/useStores';

import Button from '../../../../components/@common/Button';

import { CardCompanyList } from '../../../../types';
import Container from './styles';

function CardCompanySelect({ onChange, handleModalClose }) {
  const { CardWallet } = useStores();
  const CompanyList: CardCompanyList = CardWallet.company;

  const onClickCompanyButton = (event) => {
    handleModalClose();
    onChange(event);
  };

  return (
    <Container>
      {Object.entries(CompanyList).map(([id, { name, color, icon }]) => (
        <button
          type="button"
          className="card-company-item"
          name="companyId"
          key={id}
          onClick={onClickCompanyButton}
          value={id}
        >
          <div className="icon" data-color={color}>
            {icon}
          </div>
          <div className="name">{name}</div>
        </button>
      ))}

      <Button className="company-modal-close" size="large" onClick={handleModalClose}>
        선택 취소
      </Button>
    </Container>
  );
}

CardCompanySelect.defaultProps = {
  onChange: () => {},
  handleModalClose: () => {},
};

CardCompanySelect.propTypes = {
  onChange: PropTypes.func,
  handleModalClose: PropTypes.func,
};

export default observer(CardCompanySelect);
